import React, { useRef, forwardRef, useState, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { ChevronRightIcon } from "@heroicons/react/16/solid";

interface ReportSectionDividerProps {
    children?: React.ReactNode;
    id?: string;
    label?: string;
    locked?: boolean;
    toggle?: boolean;
    warningLock?: boolean;
}

const ReportSectionDivider = forwardRef<HTMLDivElement, ReportSectionDividerProps>(({
    children,
    id = "",
    label = "",
    locked = false,
    toggle = false,
    warningLock = false
}, ref) => {

    const [opened, setOpened] = useState(locked);
    const clicker = useRef<HTMLDivElement>(null);

    // ---=== Render ===--- //

    useEffect( // Corrected useEffect import
        () => {
            if (!locked && opened) {
                if (clicker.current) {
                    clicker.current.click();
                }
            }
        },
        [toggle]
    );

    useEffect( // Corrected useEffect import
        () => {
            if (!locked && opened) {
                if (clicker.current) {
                    clicker.current.scrollIntoView({ behavior: "smooth" });
                }
            }
        },
        [opened]
    );

    return (
        <div id={id} ref={ref} className={`w-full flex-col`}>
            <div className={"inline-flex relative mb-4 mt-2 items-center justify-center w-full py-2"}>
                <hr className="w-full h-0.5 bg-gray-200 border-0 rounded "/>
                <div
                    ref={clicker}
                    onClick={() => { !locked && setOpened(!opened);}}
                    className={`inline-flex absolute px-2 -translate-x-1/2 bg-white left-1/2 text-center text-gray-900 text-lg font-semibold leading-tight ${locked ? "" : "cursor-pointer"}`}
                >
                    {
                        warningLock &&
                            <img src="/icons/WarningLock.svg" className="h-5 w-5 pr-1" alt="icon"/>
                    }
                    {
                        label
                    }
                    {
                        !locked &&
                        (
                            opened
                                ? <ChevronDownIcon className="h-5 w-5 translate-y-1 text-gray-700 relative" aria-hidden="true"/>
                                : <ChevronRightIcon className="h-5 w-5 translate-y-0.5 text-gray-700 relative" aria-hidden="true"/>
                        )
                    }
                </div>
            </div>
            <div className={`w-auto flex-col ${opened ? "visible" : "hidden"}`}>
                {
                    children
                }
            </div>
        </div>
    );
});

ReportSectionDivider.displayName = "ReportSectionDivider";

export default ReportSectionDivider;